import type { SortBy } from './types';
import { log } from "@/helpers/utils";

export default function prepareSorts(sortBy: SortBy) {
  const sortsPrepared = sortBy.fieldName != null ? [sortBy] : [];
  return sortsPrepared;
}